import { animate, animation, style } from '@angular/animations';

export const slideInHorizontal = animation(
  [
    style({
      opacity: 0,
      transform: 'translateX({{ translateX }})',
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      style({
        opacity: 1,
        transform: 'translateX(0)',
      }),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      easing: 'ease-in',
      translateX: '10%', // can be any unit
    },
  },
);

export const slideInVertical = animation(
  [
    style({
      opacity: 0,
      transform: 'translateY({{ translateY }})',
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      style({
        opacity: 1,
        transform: 'translateY(0)',
      }),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      easing: 'ease-in',
      translateY: '10%', // can be any unit
    },
  },
);
